<ul class="nav navbar-nav navbar-nav-right ms-auto">
  <li class="nav-item dropdown" dropdown #dropdown="bs-dropdown" placement="bottom right">
    <a class="nav-link d-flex align-items-center" data-toggle="dropdown" data-gatm="header.user" role="button"
       aria-haspopup="true" aria-expanded="false" dropdownToggle id="header-info">
      <app-svg-icon type="question_circle" size="large"/>
    </a>

    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
      <ng-template ngFor let-item [ngForOf]="infoMenuItems">
        <a *ngIf="item.label && item.visible" class="dropdown-item" data-toggle="modal"
           [attr.data-gatm]="item.label"
           (click)="runLoggedAction(item)"
           [class.disabled]="!item.enabled"
           [attr.id]="item.id ? item.id : null">
          <span
          [innerHTML]="item.label  | translate: {'0': applicationVersion} "></span>
          <span class="badge badge-secondary" *ngIf="item.shortcut">{{ item.shortcut | translateShortcut }}</span>
        </a>
        <hr *ngIf="!item.label" class="separator">
      </ng-template>
    </div>
  </li>

  <li class="nav-item dropdown" dropdown #dropdown="bs-dropdown" placement="bottom right">
    <a class="nav-link d-flex align-items-center" data-toggle="dropdown" role="button"
       aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false" id="header-language-dropdown">
      <span class="text-uppercase">{{ currentLanguage.langCode }}</span>
      <app-svg-icon type="caret_down" size="medium-small" class="ms-1"/>
    </a>

    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
      <ng-template ngFor let-language [ngForOf]="languages">
        <a class="dropdown-item"
           (click)="updateCurrentLanguage(language.langCode)"
           [class.selected]="currentLanguage == language">
          <span>{{ language.langNativeName }}</span>
        </a>
      </ng-template>
    </div>
  </li>


  <li class="nav-item dropdown" *ngIf="isLoggedIn" dropdown #dropdown="bs-dropdown" placement="bottom right">
    <a class="link" data-toggle="dropdown" data-gatm="header.user" role="button" aria-haspopup="true"
       aria-expanded="false" dropdownToggle (click)="false" id="main-header-user">
      <app-svg-icon type="user" class="d-inline-block" size="large"/>
    </a>
    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
      <div class="dropdown-info-item" *ngIf="isLoggedIn">
        <strong *ngIf="showUserName">{{ userName }}</strong>
        {{ userEmail }}
      </div>
      <a class="dropdown-item" data-gatm="header.options.profile" (click)="openCDCProfile()"
         *ngIf="openCDCProfileAvailable">
        <app-svg-icon type="user" size="medium-small"/>
        {{ 'header.options.profile' | translate }}
      </a>
      <a class="dropdown-item"
         *ngIf="isRegisteredUserAccount && settingsVisible"
         (click)="actionSetting()"
         [clickFilter]="settingsEnabled"
         data-gatm="header.options.settings"
         [class.disabled]="!settingsEnabled">
        <app-svg-icon type="user" size="medium-small"/>
        {{ 'header.options.settings' | translate }}
      </a>
      <a *ngIf="user?.isAdmin()" class="dropdown-item" (click)="manageUserRights()">
        <app-svg-icon type="people" size="medium-small"/>
        {{ 'header.options.user_rights_management' | translate }}
      </a>
      <a *ngIf="loginOutAvailable" class="dropdown-item" data-gatm="header.options.loinout"
         (click)="logout()"
         id="main-header-logout">
        <app-svg-icon type="login" size="medium-small"/>
        {{'main.header.dropdown.logout' | translate }}
      </a>
    </div>
  </li>

  <button class="btn btn-primary" *ngIf="shouldShowLoginButton()" (click)="login()">{{'login.login_part.login_button.label' | translate}}</button>
</ul>
